import React from 'react';
import { Button, PRIMARY, SECONDARY } from '@glu/buttons-react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@glu/theming';
import withLocale from 'components/withLocale/withLocale';

const useStyles = createUseStyles(
  ({ spacing: { unit }, typography: { headline2 }, palette: { primary } }) => ({
    modalHeader: {
      fontSize: headline2.fontSize,
      paddingBottom: 1.5 * unit,
      textTransform: 'uppercase',
    },
    modalText: {
      paddingBottom: '30px',
      whiteSpace: 'pre-wrap',
    },
    animatingButton: {
      transitionTimingFunction: 'cubic-bezier(0, 0.25, 1)',
      position: 'relative',
      overflow: 'hidden',
      zIndex: '1',
      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        left: '0',
        width: '100%',
        height: '100%',
        borderRadius: '10rem',
        zIndex: '-2',
      },
      '&:before': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        left: '0',
        width: '0%',
        height: '100%',
        backgroundColor: primary.darkBackground,
        transition: 'all 0s',
        transitionTimingFunction: 'cubic-bezier(0, 0.25, 1)',
        borderRadius: '10rem',
        zIndex: '-1',
      },
      '&.animating': {
        color: '#fff',
        '&:before': {
          transition: 'all 1s',
          width: '100%',
        },
      },
    },
  }),
);

const ActionConfirmation = ({ execute, locale, words, setConfirmation }) => {
  const classes = useStyles();
  const closeConfirmation = () => setConfirmation(null);
  const [disableButton, setDisableButton] = React.useState(false);
  return (
    <div>
      {words.header && <h3 className={classes.modalHeader}>{words.header}</h3>}
      <p className={classes.modalText}>{words.title}</p>
      <Button
        variant={PRIMARY}
        className={`btn btn-primary${
          disableButton ? `${classes.animatingButton} animating` : classes.animatingButton
        }`}
        style={{ marginRight: '15px' }}
        data-qa="proceed"
        disabled={disableButton}
        type="button"
        onClick={() => {
          setDisableButton(true);
          execute();
        }}
      >
        {disableButton ? words.presentTenseAction : words.action}
      </Button>
      <Button
        className="btn btn-secondary"
        variant={SECONDARY}
        data-qa="cancel"
        type="button"
        onClick={closeConfirmation}
      >
        {locale['common.cancel']}
      </Button>
    </div>
  );
};

ActionConfirmation.propTypes = {
  execute: PropTypes.func.isRequired,
  setConfirmation: PropTypes.func.isRequired,
  words: PropTypes.shape({
    header: PropTypes.string,
    title: PropTypes.string,
    presentTenseAction: PropTypes.string,
    action: PropTypes.string,
  }).isRequired,
};

export default withLocale(ActionConfirmation);
